import React from "react";
import { useBloc } from "src/state/state";
import { VideoPlayerLibInterface } from "src/state/VideoPlayerCubit/VideoPlayerCubit";
import type { VideoPlayerOptions } from "./FullVideoPlayerBloc";
import FullVideoPlayerBloc from "./FullVideoPlayerBloc";

type UseVideoResponse = [
  (
    videoOptions: VideoPlayerOptions & {
      target: HTMLVideoElement | null;
    }
  ) => void,
  VideoPlayerLibInterface | undefined
];

const useVideoInline = (): UseVideoResponse => {
  const [{ player }, { initVideo, disposePlayer }] = useBloc(
    FullVideoPlayerBloc,
    {
      create: () => new FullVideoPlayerBloc()
    }
  );

  const initVideoHookFn = (
    videoOptions: VideoPlayerOptions & {
      target: HTMLVideoElement | null;
    }
  ): void => {
    void initVideo(videoOptions.target, {
      ...videoOptions
    });
  };

  React.useEffect(() => {
    return () => {
      disposePlayer();
    };
  }, []);

  return [initVideoHookFn, player];
};

export default useVideoInline;
